import type { RootState } from "@/app/store";
import { createSelector } from "@reduxjs/toolkit";

const selectLeaseCompsState = (state: RootState) => state.leaseComps;

export const selectLeaseComps = createSelector(
  selectLeaseCompsState,
  (s) => s.items,
);

export const selectLeaseCompFieldRules = createSelector(
  selectLeaseCompsState,
  (s) => [...s.fieldRules].sort((a, b) => a.order - b.order),
);

export const selectActiveLeaseCompFieldRules = createSelector(
  selectLeaseCompFieldRules,
  (rules) => rules.filter((r) => r.isActive),
);

export const selectActiveLeaseCompFieldKeys = createSelector(
  selectLeaseCompsState,
  (s): Set<string> => {
    const keys = new Set<string>();
    s.fieldRules.forEach((f) => {
      if (f.isActive) keys.add(f.key);
    });
    return keys;
  },
);

export const selectCurrentLeaseCompId = createSelector(
  selectLeaseCompsState,
  (s) => s.currentLeaseCompId,
);

export const selectCurrentLeaseComp = createSelector(
  selectLeaseComps,
  selectCurrentLeaseCompId,
  (items, id) =>
    id ? (items.find((c) => c.leaseCompId === id) ?? null) : null,
);

export const selectVisibleLeaseComps = createSelector(selectLeaseComps, (items) =>
  items.filter((c) => !c.isHidden),
);

export const selectIsLeaseCompsDrawerOpen = createSelector(
  selectLeaseCompsState,
  (s) => s.isDrawerOpen,
);

export const selectIsLeaseCompsLoading = createSelector(
  selectLeaseCompsState,
  (s) => s.isLoading || s.isFieldRulesLoading,
);

export const selectLeaseCompsError = createSelector(
  selectLeaseCompsState,
  (s) => s.error,
);

export const selectLeaseCompMediaFiles = createSelector(
  selectLeaseCompsState,
  (s) => s.mediaFiles,
);
